<template lang="pug">
  #hair-color-bar-location-hero(v-if="location")
    .row.top
      .imagery.xs-12.sm-12.md-6
        HCBLocationsHeroCarousel(:images="carouselImages" v-if="carouselImages && carouselImages.length")
        .row.bottom.xs-hide.sm-hide
          .brand-color-1(v-html="locationCmsData")
      .color-bar-title.xs-12.sm-12.md-6
        .title.xs-mb-20.md-mb-0
          p.brand-color-1.bold.xs-f-medium.max-at-tweak.mb-10.capitalize {{ preTitle }}
          h1.name.xs-f-grande.md-f-xxgrande.f-secondary.brand-color-1.max-at-tweak.capitalize {{ location.name }}
          p.subtitle.mt-10.brand-color-1(v-if="subtitle") {{ subtitle }}
        .hours(v-if="!location.hasOpened")
          h2.xs-f-small.bold.brand-color-1 Opening {{ $formatDate(location.openingDate , 'MMMM DD, YYYY') }}

        .hours.xs-f-small.brand-color-1.bold.max-at-tweak(v-else)
          .xs-12
            .hours-today
              .open
                p.bold.brand-color-1 {{ hoursToday ? 'Open Today' : 'Closed Today' }}
                p.hours-list(v-if="hoursToday" v-html="hoursToday")

            .hours-expanded
              Transition(name="hours-expanded")
                .hours-expanded-open(v-if="expandHours")
                  .xs-12(v-for="(day, index) in formattedWeekDaysInfo" :key="index + day.text")
                    .xs-7.md-6 {{ day.text }}
                    .xs-5.md-6(v-if="day.open")
                      .xs-12(v-for="(block, index) in day.hours" :key="index + '-start-time'") {{block.startTimeFormatted}}-{{ block.endTimeFormatted }}
                    .xs-5.md-6(v-else) Closed

          button.mr-btn.btn-reset.expand-hours(@click="toggleHours()")
            mr-icon.xs-f-medium.max-at-tweak(v-if="expandIcon" :name="expandIcon")

        .contacts
          a.contact(:href="location.googleMapsLink" @click="trackMREvent('HCB Location Page - Address clicked')" target="_blank")
            .icon
              mr-icon.brand-color-1(v-if="heroIcons" :name="heroIcons.map" :fill="false")
            span.brand-color-1 {{ location.shortAddress }}
          a.contact(:href="'tel:' + location.phone" @click="trackMREvent('HCB Location Page - Phone # clicked')")
            .icon
              mr-icon.brand-color-1(v-if="heroIcons" :name="heroIcons.phone" :fill="false")
            span.brand-color-1 {{ location.phone }}
          a.contact(:href="'mailto:' + location.emailAddress" @click="trackMREvent('HCB Location Page - Email clicked')")
            .icon
              mr-icon.brand-color-1(v-if="heroIcons" :name="heroIcons.mail" :fill="false")
            span.brand-color-1 {{ location.emailAddress }}

        .book-now
          StickyWrap(stop-at="footer")
            .cta-wrap
              a.mr-btn.full-width.xs-f-small.sm-f-small.md-f-xsmall.max-at-tweak(@click="trackMREvent('HCB Location Page - Book now clicked')" :href="`/colorbar/booking/${location.code}`" data-mr-ass="hcb-individual-hero-colorbar-link")
                span {{ !location.hasOpened ? 'pre-' : '' }}book now
          .row.bottom.md-hide.lg-hide.mt-20
            .brand-color-1(v-html="locationCmsData")
</template>

<script>
  import { mapState } from 'vuex';
  import StickyWrap from "@components/StickyWrap/stickyWrap";
  import HCBLocationsHeroCarousel from './HCBLocationsHeroCarousel';
  import { getCollapsedLocationOpenHours } from '@utilities/mrVueUtils';
  import MrIcon from '@components/MrIcon';

  export default {
    name: 'HairColorBarLocationsHero',

    components: {
      StickyWrap,
      HCBLocationsHeroCarousel,
      MrIcon
    },

    props: {
      heroSettings: {
        type: Object,
        default: () => {}
      }
    },

    data: () => ({
      expandHours: false,
      icons: {
        phone: 'phone-circle',
        map: 'map-circle',
        mail: 'mail-circle'
      }
    }),

    computed: {
      ...mapState('colorbar', ['location']),

      locationCmsData() {
        let about = this.location?.cmsData?.about;
        if (about) {
          about = about?.split('See nearby')[0];
        }
        return about ? about : false;
      },

      formattedWeekDaysInfo() {
        let locationHours = {};
        if (this.location?.hours) {
          locationHours = getCollapsedLocationOpenHours(this.location?.hours);
        }
        return locationHours;
      },

      openToday() {
        const today = new Date();
        return this.location?.activeHours[today.getDay()]?.open;
      },

      hoursToday() {
        const today = new Date();
        let todaysHours = {};
        if (this.location?.activeHours?.length) {
          todaysHours = this.location?.activeHours[today.getDay()];
        }
        if (!this.openToday) {
          return;
        }
        if (todaysHours?.hours?.length == 1) {
          let hours = todaysHours.hours[0];
          return `${hours.startTime} - ${hours.endTime}`;
        } else {
          return todaysHours.hours.map((hour, index) => {
            if (index === 0) {
              return `${hour.startTime} - ${hour.endTime}`;
            } else {
              return `${hour.startTime} - ${hour.endTime}`;
            }
          }).join('<br>');
        }
      },

      expandIcon() {
        return this.expandHours ? 'less' : 'more';
      },

      heroImages() {
        return this.heroSettings?.defaultLocationImages || [];
      },

      heroIcons() {
        return this.heroSettings?.icons || this.icons;
      },

      subtitle() {
        return this.heroSettings?.subtitle || '';
      },

      preTitle() {
        return this.heroSettings?.preTitle || 'Color your hair at';
      },

      carouselImages() {
        let images = [];
        let firstTwoImages = this.location.carouselImages?.slice(0, 2);
        firstTwoImages?.map((m => images.push(m)));
        this.heroImages?.map((m => images.push(m.image)));
        return images;
      },
    },

    methods: {
      toggleHours() {
        this.expandHours = !this.expandHours;
        if (this.expandHours) {
          this.trackMREvent('HCB Location Page - Hours opened');
        }
      }
    }
  };
</script>

<style lang="stylus">
  #hair-color-bar-location-hero
    padding 0.5em 1.31em
    max-width 1300px
    margin 0 auto

    @media mq-desktop-plus
      padding 0.5em 3.75em

    .top
      display flex
      flex-direction row
      margin-top 4em
      justify-content center

      .imagery
        @media mq-desktop-plus
          margin-bottom 5rem

      .color-bar-title
        display flex
        flex-direction column
        padding 0
        justify-content space-between
        margin-bottom 2.5rem

        @media mq-desktop-plus
          padding 1rem 7.56rem 1rem 1rem
          margin-bottom 0

        .hours
          padding 1em 0
          display flex
          flex-direction row
          border-top 1px solid ui-color-5
          border-bottom 1px solid ui-color-5
          justify-content space-between
          align-items center

          .hours-expanded-enter-active,
          .hours-expanded-leave-active
            transition max-height 0.5s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.5s ease-in-out
            overflow hidden
          .hours-expanded-enter-from,
          .hours-expanded-leave-to
            max-height 0
            opacity 0
          .hours-expanded-enter-to,
          .hours-expanded-leave-from
            max-height 500px
            opacity 1

          .hours-today
            .open
              width 100%
              display flex
              flex-direction row

            .hours-list
              margin-left 1em

          .expand-hours
            width 2em
            height 2em
            background-color transparent
            color brand-color-1

        .contacts
          display flex
          flex-direction column
          padding-bottom 1.5em
          border-bottom 1px solid ui-color-5
          .contact
            display flex
            flex-direction row
            margin-top 1em
            color brand-color-1
            align-items center

            span
              font-weight 700

            .icon
              margin-right 0.5em
              display flex
              align-items center
              justify-content center
              font-size 26px

        .book-now
          margin-top 1.5em

    .bottom
      p
        margin 3% 0em
        line-spacing 18.2px

    @media mq-tablet-less
      .top
        flex-direction column-reverse
        align-items center
        margin-top 1em

    @media mq-desktop-md-plus
      .color-bar-title
        height 40em
        margin-left 5%

</style>